import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { setToken } from '@/lib/auth';

import { API_BASE_URL } from '@/config/api';
const API = API_BASE_URL;

export default function Register() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${API}/auth/register`,
        { name, email, password },
        { withCredentials: true }
      );
      if (response.data.session_token) {
        setToken(response.data.session_token);
      }
      toast.success('Account created successfully!');
      navigate('/dashboard', { state: { user: response.data } });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen hero-bg flex items-center justify-center px-4">
      <div className="noise-texture absolute inset-0 pointer-events-none"></div>
      <div className="relative z-10 bg-white rounded-md p-8 w-full max-w-md card-shadow">
        <div className="text-center mb-6">
          <div className="text-6xl mb-2">☘️</div>
          <h1 className="font-bebas text-4xl text-emerald-900 tracking-wider">Join The Pool</h1>
          <p className="font-manrope text-gray-600">Create your Shamrock Pool account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name" className="font-manrope">Name</Label>
            <Input
              id="name"
              data-testid="name-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="email" className="font-manrope">Email</Label>
            <Input
              id="email"
              data-testid="email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="password" className="font-manrope">Password</Label>
            <Input
              id="password"
              data-testid="password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              className="mt-1"
            />
          </div>
          <Button
            data-testid="register-submit-button"
            type="submit"
            disabled={loading}
            className="w-full btn-primary py-3 rounded-md"
          >
            {loading ? 'Creating account...' : 'Create Account'}
          </Button>
        </form>

        <p className="text-center mt-6 font-manrope text-gray-600">
          Already have an account?{' '}
          <Link to="/login" data-testid="login-link" className="text-emerald-900 font-bold hover:text-amber-600">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}